import { render, staticRenderFns } from "./CatalogueList.vue?vue&type=template&id=185a4fae&scoped=true&"
import script from "./CatalogueList.vue?vue&type=script&lang=ts&"
export * from "./CatalogueList.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogueList.vue?vue&type=style&index=0&id=185a4fae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185a4fae",
  null
  
)

export default component.exports